module.exports = __webpack_public_path__ + "img/availableColors@2x.b121441.webp";